import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { actionItemCommentsKey } from '@pages/ActionItem/services/useActionItemCommentsQuery';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';

import { actionItemKey } from '../actionItem/useActionItemQuery';
import { listByInstPointKey } from '../useListByInstPointQuery';

const sensorReplaceOneStepFn = (data) =>
  apiClient.post(`${APP_API_URL}sensor-replace-no-ai/one-step-replacing`, data);

export const useSensorReplaceOneStepMutation = () => {
  const queryClient = useQueryClient();
  const { actionItemId } = useParams();

  return useMutation({
    mutationFn: sensorReplaceOneStepFn,
    onSuccess: ({ data }) => {
      if (data.status === 'ok') {
        queryClient.invalidateQueries({ queryKey: [listByInstPointKey()[0]] });
        queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
        queryClient.invalidateQueries({ queryKey: actionItemKey(actionItemId) });
        queryClient.invalidateQueries({ queryKey: actionItemCommentsKey(actionItemId) });
      }
    },
  });
};
